import { Button } from '@mui/material';
import styled from 'styled-components';

export const LoginButton = styled(Button)`
  && {
    height: 32px;
    box-shadow: none;

    &:hover {
      box-shadow: none;
    }
  }
`;
